import { UseQueryResult, useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";

import { getDomain } from "../core/cookies.core";
import { ShopTiny, ShopType } from "../types/shop";
import useShopList from "./useShopList.hook";
import { useShopId } from "../core/login.core";
import shopCore, { setShopId } from "../core/shop.core";

export default function useShop() {
  const shopId = useShopId();
  const shopListQuery = useShopList();

  const selectedShop = getSelectedShop(shopListQuery, shopId as string);
  const isMerchant = selectedShop ? selectedShop.shopType === ShopType.multiMerchant : false;
  const userShopRole = selectedShop ? selectedShop.userShopRole : null;

  function selectShop(shopId: string) {
    setShopId(shopId);
    Cookies.remove("retailShopId", { domain: getDomain() });

    window.location.reload();
  }

  return {
    selectedShop,
    isMerchant,
    userShopRole,
    selectShop,
  };
}

function getSelectedShop(shopListQuery: UseQueryResult<ShopTiny[] | undefined, Error>, shopId: string | null) {
  if (!shopListQuery.isFetched) return null;
  if (!shopId) return null;

  const shopList = shopListQuery.data;

  const selectedShop = shopList?.find((s) => s.id === shopId);
  if (!selectedShop) return null;

  return selectedShop;
}

export function useShopFull() {
  const shopId = useShopId();

  return useQuery({
    queryKey: ["shop", shopId],
    queryFn: () => shopCore.getShop(),
  });
}
